import MemberInfoCard from './member.card';
import DashboardCard from './dashboard.card';

export default {
  MemberInfoCard,
  DashboardCard,
};
